import { cva } from 'class-variance-authority';

export const cvaFreeParkingPlacesList = cva([
  'FreeParkingPlacesListStyles-cvaFreeParkingPlacesList',
  'relative flex flex-col',
  'max-h-[64vh]',
  'overflow-y-auto scroll-touch',
  ' pb-4 ',
]);

export const cvaFreeParkingPlacesBox = cva([
  'FreeParkingPlacesListStyles-cvaFreeParkingPlacesBox',
  'grid grid-cols-2 gap-1.2',
]);

export const cvaFreeParkingPlacesItem = cva([
  'FreeParkingPlacesListStyles-cvaFreeParkingPlacesItem',
  'pt-1.2 pb-1 px-1.6',
  'bg-cSecondaryGray rounded-[0.8rem]',
]);

export const cvaFreeParkingPlacesPrice = cva([
  'FreeParkingPlacesListStyles-cvaFreeParkingPlacesPrice',
  'mb-0.2',
  'text-header-s',
]);

export const cvaFreeParkingPlacesListTop = cva(
  [
    'FreeParkingPlacesListStyles-cvaFreeParkingPlacesListTop',
    'sticky top-0 ',
    'pb-1.2',
    'bg-cDarkGray text-[#7C7B83] pt-0.6',
  ],
  {
    variants: {
      isScroll: {
        true: [
          'before:absolute before:bottom-[-2rem] before:left-0 before:z-[30]',
          'before:w-full before:h-2.4',
          'before:bg-gradient-to-b from-[#070417] to-transparent before:absolute before:opacity-[0.3]',
        ],
      },
    },
  }
);
